import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import {
  InspectionAudience,
  InspectionService,
} from '../../services/inspection/inspection.service';
import { InspectionCaseDetail } from '../../models/inspection';

/**
 * Buyer and supplier Inspection Case routes are exact mirrors (contract
 * `inspection-module-api-contract-v2.md` §0), routed by the `role` route data
 * the way `DashboardLayoutComponent.ngOnInit` already reads it elsewhere.
 */
export const inspectionCaseResolver: ResolveFn<
  InspectionCaseDetail | undefined
> = route => {
  const inspectionService = inject(InspectionService);

  const caseId = Number(route.paramMap.get('caseId'));
  const role = route.data['role'] as InspectionAudience;

  return inspectionService
    .getCase(role, caseId)
    .pipe(map(response => response?.inspection_case));
};
